import { useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import CreationToolStep from '../types/steps'

/**
 * Returns the next step (if available)
 */
export function useCreationNextStep(steps: CreationToolStep[]): CreationToolStep | undefined {
    const [nextStep, setNextStep] = useState<CreationToolStep>()
    const { pathname } = useLocation()

    useEffect(() => {
        const active = steps.find(step => {
            const route = CreationToolStep.route(step)
            return pathname.indexOf(route) > -1
        })

        if (active) {
            setNextStep(steps[steps.indexOf(active) + 1])
        } else {
            setNextStep(undefined)
        }
    }, [steps, pathname])

    return nextStep
}
